const block = document.querySelector('.homepage-hero-block');
if (block) {
    const subSlideImages = block.querySelectorAll('.row[data-sub-slide-index]');
    const subSlideHeadlines = block.querySelectorAll('.headline [data-sub-slide-index]');
    const slideRow = block.querySelector('.row.align-items-lg-center');
    let currentIndex = 0;
    let intervalId;
    const BREAKPOINT = 1034;

    // Check if we're on desktop
    const isDesktop = () => window.innerWidth >= BREAKPOINT;

    // Set fixed height based on tallest slide
    const setFixedHeight = () => {
        if (!isDesktop()) return;

        let maxHeight = 0;
        const currentSlideIndex = currentIndex.toString();

        // Store current visibility state
        const visibleSlides = Array.from(subSlideImages).filter(slide =>
            slide.style.display === 'flex' && slide.dataset.subSlideIndex === currentSlideIndex
        );
        const visibleHeadlines = Array.from(subSlideHeadlines).filter(headline =>
            headline.style.display === 'block' && headline.dataset.subSlideIndex === currentSlideIndex
        );

        // Hide all slides first
        hideAllSlides();

        // Measure height for each slide configuration individually
        const uniqueIndices = new Set();
        subSlideImages.forEach(slide => {
            uniqueIndices.add(slide.dataset.subSlideIndex);
        });

        uniqueIndices.forEach(index => {
            // Show only this index's slides
            subSlideImages.forEach(slide => {
                if (slide.dataset.subSlideIndex === index) {
                    slide.style.display = 'flex';
                }
            });
            subSlideHeadlines.forEach(headline => {
                if (headline.dataset.subSlideIndex === index) {
                    headline.style.display = 'block';
                }
            });

            maxHeight = Math.max(maxHeight, slideRow.offsetHeight);

            // Hide again before measuring next
            hideAllSlides();
        });

        // Set the row height to the tallest configuration
        slideRow.style.height = `${maxHeight}px`;

        // Restore visibility of current slide
        visibleSlides.forEach(slide => {
            slide.style.display = 'flex';
        });
        visibleHeadlines.forEach(headline => {
            headline.style.display = 'block';
        });
    };

    // Hide all slides
    const hideAllSlides = () => {
        subSlideImages.forEach(slide => {
            slide.style.display = 'none';
        });
        subSlideHeadlines.forEach(headline => {
            headline.style.display = 'none';
        });
    };

    // Show slide at specific index
    const showSlide = (index) => {
        hideAllSlides();
        subSlideImages.forEach(slide => {
            if (slide.dataset.subSlideIndex === index.toString()) {
                slide.style.display = 'flex';
            }
        });
        subSlideHeadlines.forEach(headline => {
            if (headline.dataset.subSlideIndex === index.toString()) {
                headline.style.display = 'block';
            }
        });
    };

    // Move to next slide
    const nextSlide = () => {
        if (!isDesktop()) return;
        currentIndex = (currentIndex + 1) % (subSlideImages.length);
        showSlide(currentIndex);
    };

    // Initialize slider
    const initSlider = () => {
        // Hide all slides before any measurements
        hideAllSlides();

        if (isDesktop()) {
            // Set fixed height
            setFixedHeight();
            // Show first slide
            showSlide(0);
            // Start interval
            intervalId = setInterval(nextSlide, 4000);
        } else {
            // On mobile, show the first slide
            // const lastIndex = subSlideImages.length - 1;
            showSlide(0);
            slideRow.style.height = 'auto';
        }
    };

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        clearInterval(intervalId);

        resizeTimer = setTimeout(() => {
            if (isDesktop()) {
                setFixedHeight();
                intervalId = setInterval(nextSlide, 5000);
            } else {
                // On mobile, show the first slide
                // const lastIndex = subSlideImages.length - 1;
                showSlide(0);
                slideRow.style.height = 'auto';
            }
        }, 250);
    });

    // Hide all slides immediately when script loads
    hideAllSlides();

    // Initialize when DOM is loaded
    initSlider();
}

